module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sekundaerlogo_postale_vestfold_telemark_pos.f165f632.svg";